function toggleInputs(show, input_container) {
  const inputs = input_container.querySelectorAll('[data-form-field-value]');

  if (show) {
    inputs.forEach((input) => {
      const isRequired = input.dataset.required
      if (isRequired == "true") {
        input.setAttribute("required", isRequired)
      } else {
        input.removeAttribute("required")
      }

      input.setAttribute("data-visible", "true")
    })
  } else {
    inputs.forEach((input) => {
      input.removeAttribute("required")
      input.setAttribute("data-visible", "false")
      input.setCustomValidity('');
    })
  }
  input_container.style.display = show ? "inherit" : "none";

}

export function init(form_container) {
  const conditionalElements = form_container.querySelectorAll('[data-conditional="true"]');

  [...conditionalElements].forEach((conditionalElement) => {
    document
      .getElementById(conditionalElement.dataset.dependsOn)
      .addEventListener('change', (event) => {
        const show = JSON.parse(conditionalElement.dataset.showOn).includes(event.target.value);

        toggleInputs(show, conditionalElement)
      });

    toggleInputs(false, conditionalElement)
  });
}
